import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=e7c2a3ae&"
import script from "./basic.vue?vue&type=script&lang=js&"
export * from "./basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7c2a3ae')) {
      api.createRecord('e7c2a3ae', component.options)
    } else {
      api.reload('e7c2a3ae', component.options)
    }
    module.hot.accept("./basic.vue?vue&type=template&id=e7c2a3ae&", function () {
      api.rerender('e7c2a3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/basic.vue"
export default component.exports